import { render, staticRenderFns } from "./PartnerAccount.vue?vue&type=template&id=490aa09b&scoped=true"
import script from "./PartnerAccount.vue?vue&type=script&lang=js"
export * from "./PartnerAccount.vue?vue&type=script&lang=js"
import style0 from "./PartnerAccount.vue?vue&type=style&index=0&id=490aa09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490aa09b",
  null
  
)

export default component.exports